import { render, staticRenderFns } from "./SinSeguimiento.vue?vue&type=template&id=4db34e0c&scoped=true&"
import script from "./SinSeguimiento.vue?vue&type=script&lang=js&"
export * from "./SinSeguimiento.vue?vue&type=script&lang=js&"
import style0 from "./SinSeguimiento.vue?vue&type=style&index=0&id=4db34e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db34e0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog})
